import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication';
import { EwalletService } from 'src/modules/features/admin/services/ewallet';

@Injectable({ providedIn: 'root' })
export class WalletAuthGuard implements CanActivate {
  constructor(private router: Router, private walletService: EwalletService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    return this.walletService
      .get2FAConfig({ configId: 'E_WALLET_PAGE_ACTIVE' })
      .pipe(
        map((res: any) => {
          if (res.value === 'true') {
            return true;
          } else {
            this.router.navigate(['/home-page']);
            alert("You're not authorised to view this page");
            return false;
          }
        }),
        catchError((error) => {
          this.router.navigate(['/home-page']);
          alert("You're not authorised to view this page");
          return of(false);
        })
      );
  }
}
